import { Grid } from "@mui/material";
import { green, red, grey } from "@mui/material/colors";
import TodayIcon from "@mui/icons-material/Today";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useSessao } from "../../redux/sessao/sessaoHooks";
import CardInformativo from "./CardInformativo";
import { useEffect, useState } from "react";
import agendamentoApi from "../../api/agendamentoApi";
import solicitacaoEmissaoCTeApi from "../../api/solicitacaoEmissaoCTeApi";
import solicitacaoPessoalApi from "../../api/solicitacaoPessoalApi";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";

export default function CardsInformativos() {
  const [sessao] = useSessao();

  const [agendamentosHoje, setAgendamentosHoje] = useState(0);
  const [solicitacoesNaoConcluidas, setSolicitacoesNaoConcluidas] = useState(0);
  const [solicitacoesPessoais, setSolicitacoesPessoais] = useState(0);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    buscarInformacoes();
  }, []);

  const buscarInformacoes = async () => {
    setLoading(true);
    const [
      resultAgendamentos,
      solicitacoesCteResult,
      solicitacaoPessoalResult,
    ] = await Promise.allSettled([
      agendamentoApi.countAgendamentosEntreDatas(new Date(), new Date()),
      solicitacaoEmissaoCTeApi.countSolicitacoesNaoConcluidasENaoExpiradas(),
      solicitacaoPessoalApi.countSolicitacoesPessoaisNaData(new Date()),
    ]);

    if (resultAgendamentos.status === "fulfilled") {
      setAgendamentosHoje(resultAgendamentos.value);
    }

    if (solicitacoesCteResult.status === "fulfilled") {
      setSolicitacoesNaoConcluidas(solicitacoesCteResult.value);
    }

    if (solicitacaoPessoalResult.status === "fulfilled") {
      setSolicitacoesPessoais(solicitacaoPessoalResult.value);
    }
    setLoading(false);
  };

  const quickStats = [
    {
      title: "Checklists Hoje",
      value: agendamentosHoje,
      icon: TodayIcon,
      color: green[500],
      permissao: true,
    },
    {
      title: "CT-e Pendentes",
      value: solicitacoesNaoConcluidas,
      icon: WarningAmberIcon,
      color: red[500],
      permissao: sessao.usuario?.perfil.podeAcessarSolicitacaoCte ?? false,
    },
    {
      title: "Solicitações Pessoais Hoje",
      value: solicitacoesPessoais,
      icon: EmojiPeopleIcon,
      color: grey[700],
      permissao:
        sessao.usuario?.perfil.podeAcessarSolicitacoesPessoais ?? false,
    },
  ];

  return (
    <Grid
      container
      spacing={2}
      style={{ display: "flex", justifyContent: "center" }}
    >
      {quickStats.map((stat, index) => (
        <Grid item>
          <CardInformativo
            loading={loading}
            title={stat.title}
            value={stat.value}
            icon={stat.icon}
            color={stat.color}
            permissao={stat.permissao}
          />
        </Grid>
      ))}
    </Grid>
  );
}
